module.exports = __webpack_public_path__ + "static/media/1008510.2feaf1e4.png";